"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SpeakerCard = require("./SpeakerCard.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WorkshopCard(props) {
  var content = props.content,
      closeCard = props.closeCard;
  var person = content.data.speaker;
  var trainers = content.data.trainers;
  return /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeaker, {
    id: "popup-".concat(person.slug)
  }, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerTop, null, trainers && trainers.length > 0 ? trainers.map(function (trainer, i) {
    return /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerAvatarWrap, {
      key: i
    }, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerAvatar, {
      src: trainer.avatar.url,
      alt: trainer.name
    }));
  }) : /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerAvatarWrap, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerAvatar, {
    src: person.avatar.url,
    alt: person.name
  })), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerDesc, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerName, null, content.data.title), trainers && trainers.length > 0 ? /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerCompany, null, trainers.map(function (trainer, i) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: trainer.name + i
    }, trainer.name, " \xA0 \xA0");
  })) : /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerCompany, null, person.name), /*#__PURE__*/_react.default.createElement(_SpeakerCard.WorkshopPopBio, {
    dangerouslySetInnerHTML: {
      __html: content.data.description
    }
  }))), content.data.content && content.data.content.length > 0 ? /*#__PURE__*/_react.default.createElement(_SpeakerCard.WorkshopInfoContainer, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.WorkshopInfoTitle, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerCompany, null, "Table of contents")), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBio, null, /*#__PURE__*/_react.default.createElement("ul", null, content.data.content.map(function (data) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: data.name
    }, "- ", data);
  })))) : null, content.data.prerequisites ? /*#__PURE__*/_react.default.createElement(_SpeakerCard.WorkshopInfoContainer, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.WorkshopInfoTitle, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerCompany, null, "Prerequisites")), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBio, {
    dangerouslySetInnerHTML: {
      __html: content.data.prerequisites
    }
  })) : null, content.data.level ? /*#__PURE__*/_react.default.createElement(_SpeakerCard.WorkshopInfoContainer, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.WorkshopInfoTitle, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerCompany, null, "Workshop level")), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBio, null, content.data.level)) : null, content.data.location ? /*#__PURE__*/_react.default.createElement(_SpeakerCard.WorkshopInfoContainer, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.WorkshopInfoTitle, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerCompany, null, "Workshop schedule & location")), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBio, {
    dangerouslySetInnerHTML: {
      __html: content.data.location
    }
  })) : null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.WorkshopButtonContainer, null, content.data.includedToPackage ? /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBtn, {
    href: content.pagesPieceOfTexts.workshopsList__freeLink || '',
    onClick: closeCard
  }, "Buy full ticket") : /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBtn, {
    href: content.pagesPieceOfTexts.workshopsList__proLink || '',
    onClick: closeCard
  }, "Buy Pro Workshop")));
}

var _default = WorkshopCard;
exports.default = _default;